module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"brand":"This card is accepted everywhere you see the {0} sign."}}')
  delete Component.options._Ctor
}
